export default "__VITE_ASSET__BiNUNpc2__"